import { Box, Divider } from "@chakra-ui/react"
import type { ReactNode } from "react"

type TransferInfoPanelProps = {
  bg: string
  summary: ReactNode
  details?: ReactNode
  meta: ReactNode
}

export default function TransferInfoPanel({
  bg,
  summary,
  details,
  meta,
}: TransferInfoPanelProps) {
  return (
    <Box bg={bg} borderWidth="1px" borderRadius="md" p={4} mb={4}>
      {summary}
      {details ? (
        <>
          <Divider my={3} />
          {details}
        </>
      ) : null}
      <Divider my={3} />
      {meta}
    </Box>
  )
}
